import { useState } from "react";
import HeaderInner from "../../utility/HeaderInner";
import { FaYoutube, FaImage, FaFilter } from "react-icons/fa";
import { galleryItems } from "../../utility/GalleryData";

const Gallery = () => {
  const [selectedItem, setSelectedItem] = useState(null);
  const [activeFilter, setActiveFilter] = useState(""); // Only one filter at a time
  const [showFilterPopup, setShowFilterPopup] = useState(false);

  const categories = ["Image", "Video"];

  const selectFilter = (filter) => {
    if (activeFilter === filter) {
      setActiveFilter(""); // unselect if already selected
    } else {
      setActiveFilter(filter);
    }
    setShowFilterPopup(false); // Close popup immediately after selection
  };

  const clearFilter = () => setActiveFilter("");

  const getYouTubeId = (url) => {
    const regExp =
      /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
    const match = url.match(regExp);
    return match && match[2].length === 11 ? match[2] : null;
  };

  const filteredItems =
    activeFilter === ""
      ? galleryItems
      : galleryItems.filter((item) => item.type === activeFilter.toLowerCase());

  return (
    <div className="mt-70">
      <HeaderInner title="Gallery" />

      <section className="py-5 bg-light">
        <div className="container-fluid px-3">
          <div className="row">
            {/* ✅ Desktop Sidebar Filters */}
            <div className="col-md-3 d-none d-md-block">
              <div
                style={{
                  position: "sticky",
                  top: "150px",
                  maxHeight: "calc(100vh - 120px)",
                  overflowY: "auto",
                }}
              >
                <div className="border p-3 mb-3 bg-white">
                  <h6 className="fw-bold fs-6 mb-2">FILTER BY</h6>
                  <div className="d-flex flex-wrap gap-2 mb-2">
                    {activeFilter ? (
                      <span
                        className="badge bg-dark text-white"
                        style={{ cursor: "pointer" }}
                        onClick={clearFilter}
                      >
                        {activeFilter} ✕
                      </span>
                    ) : (
                      <span className="text-muted small">
                        No filters applied
                      </span>
                    )}
                  </div>
                  {activeFilter && (
                    <span
                      className="text-danger small"
                      style={{ cursor: "pointer" }}
                      onClick={clearFilter}
                    >
                      Clear
                    </span>
                  )}
                </div>

                <div className="border p-3 bg-white">
                  <h6 className="fw-bold fs-6 mb-2">CATEGORIES</h6>
                  {categories.map((cat, i) => (
                    <div className="form-check mb-2" key={i}>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id={`desktop-${cat}`}
                        checked={activeFilter === cat}
                        onChange={() => selectFilter(cat)}
                      />
                      <label
                        className="form-check-label"
                        htmlFor={`desktop-${cat}`}
                      >
                        {cat}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* ✅ Gallery Grid (scrollable) */}
            <div className="col-md-9">
              <div className="row g-3">
                {filteredItems.map((item, index) => {
                  const videoId =
                    item.type === "video" ? getYouTubeId(item.src) : null;
                  return (
                    <div key={index} className="col-12 col-sm-6 col-md-4 mt-2">
                      <div
                        className="card overflow-hidden position-relative"
                        onClick={() => setSelectedItem(item)}
                        style={{ cursor: "pointer" }}
                      >
                        <img
                          src={
                            item.type === "image"
                              ? item.src
                              : `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`
                          }
                          alt={item.title}
                          className="card-img-top"
                          style={{ height: "14rem", objectFit: "contain" }}
                        />
                        <div className="position-absolute top-50 start-50 translate-middle text-white">
                          {item.type === "video" ? (
                            <FaYoutube className="text-danger fs-1" />
                          ) : (
                            <FaImage className="fs-2" />
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}
                {filteredItems.length === 0 && (
                  <div className="text-center py-5 text-muted">
                    No items found for this filter
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ✅ Mobile Filter Bar */}
      <div
        className="d-md-none d-flex justify-content-center align-items-center bg-dark text-white py-2 fixed-bottom"
        style={{ cursor: "pointer" }}
        onClick={() => setShowFilterPopup(true)}
      >
        <FaFilter className="me-2" /> Filters
      </div>

      {/* ✅ Mobile Filter Popup */}
      {showFilterPopup && (
        <div
          className="position-fixed bottom-0 start-0 w-100"
          style={{ zIndex: 1055, backgroundColor: "rgba(0,0,0,0.5)" }}
          onClick={() => setShowFilterPopup(false)}
        >
          <div
            className="bg-white rounded-top"
            style={{
              maxHeight: "80vh",
              overflowY: "auto",
              paddingBottom: "1rem",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header */}
            <div className="d-flex justify-content-between align-items-center p-3 border-bottom">
              <h6 className="modal-title mb-0">Select Filter</h6>
              <button
                type="button"
                className="btn-close"
                onClick={() => setShowFilterPopup(false)}
              ></button>
            </div>

            {/* Body */}
            <div className="p-3">
              {categories.map((cat, i) => (
                <div className="form-check mb-2" key={i}>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id={`mobile-${cat}`}
                    checked={activeFilter === cat}
                    onChange={() => selectFilter(cat)}
                  />
                  <label className="form-check-label" htmlFor={`mobile-${cat}`}>
                    {cat}
                  </label>
                </div>
              ))}

              {activeFilter && (
                <span
                  className="text-danger small"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    clearFilter();
                    setShowFilterPopup(false);
                  }}
                >
                  Clear
                </span>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Gallery;
